<div class="recruiter-landing-page bg-white text-slate-900 font-sans">
    <app-recruiter-navbar></app-recruiter-navbar>
    <app-recruiter-hero></app-recruiter-hero>
    <app-recruiter-hiring-process></app-recruiter-hiring-process>
    <app-recruiter-why-beexpert></app-recruiter-why-beexpert>
    <app-recruiter-features></app-recruiter-features>
    <!-- <app-recruiter-stats></app-recruiter-stats> -->
    <app-recruiter-testimonials></app-recruiter-testimonials>
    <!-- <app-recruiter-hiring-solutions></app-recruiter-hiring-solutions> -->
    <app-recruiter-cta></app-recruiter-cta>
    <app-recruiter-footer></app-recruiter-footer>
    <!-- <app-floating-whatsapp></app-floating-whatsapp> -->
</div>